import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=3860ae24&scoped=true"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=3860ae24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860ae24",
  null
  
)

export default component.exports